import React from "react";
import IconButton from "@mui/material/IconButton";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { themes } from "services/constants";
import { LoadingButton } from "@mui/lab";
import * as Mui from "@mui/material";
import ScheduledMaintenanceNotice from "./ScheduledMaintenanceNotice";

export { ScheduledMaintenanceNotice };

export const BackArrow = ({ actionFunction }) => {
  return (
    <IconButton
      onClick={actionFunction}
      sx={{
        textTransform: "capitalize",
        color: themes.headLine,
      }}
      variant="contained"
      size="medium"
    >
      <ArrowCircleLeftIcon color={themes.headLine} fontSize="large" />
    </IconButton>
  );
};

export const CustomTextBox = ({
  type,
  rules,
  selectedValue,
  label,
  placeHolder,
  textBoxError,
  errorMessage,
  updateDataFunction,
  disabledValue,
  onBlurFunction,
  minDate,
}) => {
  return (
    <Mui.TextField
      type={type}
      multiline={type === "multiline" ? true : false}
      rows={type === "multiline" ? 2 : 1}
      label={label}
      placeholder={placeHolder}
      value={selectedValue}
      rules={rules}
      size="small"
      onChange={(event) => {
        updateDataFunction(event);
      }}
      onBlur={onBlurFunction}
      InputLabelProps={{ shrink: true }}
      inputProps={{
        ...(type === "date" && {
          min: minDate,
        }),
      }}
      error={textBoxError}
      helperText={errorMessage}
      disabled={disabledValue}
      fullWidth
    />
  );
};

export const CustomButtonGroup = ({
  firstActionFuntion,
  firstActionName,
  secondActionFuntion,
  secountActionName,
  type,
}) => {
  return (
    <Mui.Grid container spacing={2}>
      <Mui.Stack
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <Mui.Button
          onClick={firstActionFuntion}
          sx={{
            background: themes.primary,
            textTransform: "capitalize",
            "&:hover": {
              backgroundColor: themes.primary,
            },
          }}
          variant="contained"
          size="large"
        >
          <Mui.Typography sx={{ fontSize: { xs: 0, sm: 0, md: 12, lg: 14 } }}>
            {firstActionName}
          </Mui.Typography>
        </Mui.Button>
        {type === "submit" ? (
          <Mui.Button
            onClick={secondActionFuntion}
            sx={{
              background: themes.primary,
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: themes.primary,
              },
            }}
            variant="contained"
            size="large"
            type="submit"
          >
            <Mui.Typography sx={{ fontSize: { xs: 0, sm: 0, md: 12, lg: 14 } }}>
              {secountActionName}
            </Mui.Typography>
          </Mui.Button>
        ) : (
          <Mui.Button
            onClick={secondActionFuntion}
            sx={{
              background: themes.primary,
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: themes.primary,
              },
            }}
            variant="contained"
            size="large"
          >
            <Mui.Typography sx={{ fontSize: { xs: 0, sm: 0, md: 12, lg: 14 } }}>
              {secountActionName}
            </Mui.Typography>
          </Mui.Button>
        )}
      </Mui.Stack>
    </Mui.Grid>
  );
};

export const CustomButton = ({
  actionFuntion,
  actionName,
  typeName,
  disableAction,
}) => {
  return (
    <LoadingButton
      onClick={actionFuntion}
      sx={{
        background: themes.primaryButton,
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: themes.primaryButton,
        },
        color: themes.headLine,
        fontWeight: "bold",
      }}
      type={typeName}
      variant="contained"
      size="medium"
      loading={disableAction}
      disabled={disableAction}
    >
      {actionName}
    </LoadingButton>
  );
};

export const CustomAutoComplete = ({
  dataList,
  selectedValue,
  Icons,
  updateDataFunction,
  rules,
  placeHolder,
  label,
  errorMessage,
  textBoxError,
  disableAction,
}) => {
  return (
    <Mui.Autocomplete
      disablePortal
      id="combo-box"
      size="small"
      value={selectedValue}
      options={dataList}
      InputLabelProps={{ shrink: true }}
      sx={{ width: "100%" }}
      ListboxProps={{ style: { maxHeight: "150px" } }}
      filterOptions={(options, state) => {
        return options.filter((option) =>
          option?.label?.toLowerCase().includes(state.inputValue.toLowerCase())
        );
      }}
      renderOption={(props, option) => {
        return <li {...props}>{option?.label}</li>;
      }}
      isOptionEqualToValue={(option, value) => option?.label === value?.label}
      // onInputChange={(event, value) => updateDataFunction(event, value)}
      onChange={(event, value) => updateDataFunction(event, value)}
      renderInput={(params) =>
        Icons ? (
          <Mui.TextField
            {...params}
            sx={{ background: themes.whiteColor, borderRadius: "10px" }}
            label={label}
            placeholder={placeHolder}
            size="small"
            value={selectedValue}
            rules={rules}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <Icons style={{ margin: "0 8px", color: "#a6a6a6" }} />
                  {params.InputProps.startAdornment}
                </>
              ),
            }}
            error={textBoxError}
            helperText={errorMessage}
            fullWidth
            disabled={disableAction}
          />
        ) : (
          <Mui.TextField
            {...params}
            sx={{
              background: themes.whiteColor,
              // "& .MuiOutlinedInput-root": {
              //   borderRadius: "16px", // Adjust the radius as needed
              // },
            }}
            size="small"
            InputLabelProps={{ shrink: true }}
            label={label}
            placeholder={placeHolder}
            value={selectedValue}
            validate
            error={textBoxError}
            helperText={errorMessage}
            disabled={disableAction}
            fullWidth
          />
        )
      }
    />
  );
};
